import { createAsyncThunk } from "@reduxjs/toolkit";
import { openMessage } from "../slice/messageSlice";
import { openForm } from "../slice/cameraSlice";
import { API_MASTER } from "../../constants";

export const getCameraPage = createAsyncThunk(
  "camera/page",
  async (param, thunkAPI) => {
    let filter = `name=${param.filter[0].name}&brand=${param.filter[0].brand}&type=${param.filter[0].type}&location=${param.filter[0].location}`
    if(param.filter[0].siteName !== '') {
      filter += `&siteName=${param.filter[0].siteName}`
    }
    const respone = await fetch(
      `${API_MASTER}/api/camera/page?${filter}&size=${param.size}&page=${param.page}`,
      // 
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + param.token,
          //    + param.token,
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
        }),
      }
    );
    if (respone.status === 200) {
      const responeResult = await respone.json();
      // console.log("as")
      return responeResult;
    } else {
      return {
        data: {
          content: [],
          totalElements: 0,
          totalPages: 0,
          last: true,
          size: 0,
          number: 0,
          numberOfElements: 0,
          first: true,
          empty: false,
        },
      };
    }
  }
);

export const getCameraBySitesId = createAsyncThunk('camera/siteId', async (param, thunkAPI) => {
  // console.log(param);
  const response = await fetch(`${API_MASTER}/api/camera?siteId=${param.sites}`, {
    method: 'get',
    headers: {
      Authorization: 'Bearer ' + param.token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
  })
  if (response.status === 200) {
    const responseJson = await response.json()
    return responseJson
  }
})

export const getCameraList = createAsyncThunk(
  'camera/list',
  async (param, thunkAPI) => {
    const respone = await fetch(`${API_MASTER}/api/camera`, {
      method: 'get',
      headers: new Headers({
        Authorization: 'Bearer ' + param.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
      }),
    })
    const responeResult = await respone.json()
    // console.log("as")
    return responeResult
  },
)


export const postCamera = createAsyncThunk(
  "camera/post",
  async (param, thunkAPI) => {
    // console.log(param);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + param.token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
      },
      body: JSON.stringify(param.data),
    };
    let response = await fetch(
      `${API_MASTER}/api/camera`,
      requestOptions
    );
    if (response.status === 200) {
      thunkAPI.dispatch(
        openMessage({
          message: "Insert Camera Successfull",
          type: "success",
          open: true,
        })
      );
      thunkAPI.dispatch(getCameraPage(param));
    }
    // .then(getApi())
  }
);

export const editCamera = createAsyncThunk(
  "camera/update",
  async (param, thunkAPI) => {
    // console.log(param);
    const requestOptions = {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + param.token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
      },
      body: JSON.stringify(param.data),
    };
    let response = await fetch(
      `${API_MASTER}/api/camera/${param.id}`,
      requestOptions
    );
    if (response.status === 200) {
      thunkAPI.dispatch(
        openMessage({
          message: "Berhasil Mengubah Camera",
          type: "success",
          open: true,
        })
      );
      thunkAPI.dispatch(getCameraPage(param));
    }
    if (response.status === 400) {
      thunkAPI.dispatch(
        openMessage({
          message: "Edit Camera Failed",
          type: "danger",
          open: true,
        })
      );
    }
  }
);

export const deleteCamera = createAsyncThunk(
  "camera/delete",
  async (param, thunkAPI) => {
    // console.log(param);
    const requestOptions = {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + param.token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
      },
      body: JSON.stringify(param.data),
    };
    let response = await fetch(
      `${API_MASTER}/api/camera/${param.id}`,
      requestOptions
    );
    if (response.status === 200) {
      thunkAPI.dispatch(
        openForm({ state: "delete", open: false, id: "", data: [] })
      );
      thunkAPI.dispatch(
        openMessage({
          message: "Delete Camera Successfull",
          type: "success",
          open: true,
        })
      );
      thunkAPI.dispatch(getCameraPage(param));
    }
    // .then(getApi())
  }
);
